<script>
import { fandomTranslate } from "src/modules/common_module";

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "red-cabbage"
    },
    name: {
      type: String,
      default: "recipeIngredients"
    },
    content: {
      type: Object,
      default: () => { return {}; }
    },
    containerContent: {
      type: Object,
      default: () => { return {}; }
    },
    ingredients: {
      type: Array,
      default: () => []
    },
    allergens: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    idSelector() {
      return `#${this.name}`;
    },
    backgroundClass() {
      return `bg-${this.color}`;
    },
    textClass() {
      return `text-${this.color}`;
    }
  },
  methods: {
    ft: fandomTranslate
  }
};
</script>

<template>
  <div class="recipe__ingredients">
    <div class="row px-3 px-lg-0 pl-lg-3 py-lg-4 py-3 sticky-top">
      <div data-toggle="collapse" :href="idSelector" role="button" aria-expanded="false" :aria-controls="name" class="col-12 ingredients-head px-0">
        <div class="text-white font-xs text-uppercase py-3 px-4 d-flex justify-content-between" :class="backgroundClass">
          <div>{{title}}</div>
          <span class="d-flex justify-content-center align-self-center ">
            <i class="font-sm fal fa-chevron-up"></i>
          </span>
        </div>
      </div>
      <div :id="name" class="col-12 px-0 bg-kenwood-light-grey dropdown-list border-left border-bottom border-right collapse show">
        <div v-if="allergens.length > 0" class="d-block font-xs px-4 allergens" :class="textClass">
          <div class="py-3 d-block border-bottom">
            <div class="d-inline">{{ft("recipe.allergens")}}:&nbsp;</div>
            <div v-for="(allergen, index) in allergens" class="d-inline" :key="`allergen-${index}`">
              {{allergen}}{{(allergens.length - 1) > index ? ", " : ""}}
            </div>
          </div>
        </div>
        <ul v-if="ingredients.length > 0" class="ingredients p-0">
          <li v-for="(ingredient, index) in ingredients" class="d-block ingredient px-4" :key="`ingredient-${index}`">
            <div class="py-3" :class="{'border-top': index > 0}">{{ingredient.quantity}} {{ingredient.title}}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fa-chevron-up {
  transition: transform 0.75s;
}

.collapsed {
  .fa-chevron-up {
    transform: rotate(-180deg);
  }
}

.ingredients-head {
  cursor: pointer;
}

.collapsing {
  transition: all 0.65s;
}

.ingredient {
  font-size: 1.25rem;
  font-family: $bressay-font;
}
</style>
